module.exports = __webpack_public_path__ + "static/media/tasklist.38557fc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/tasklist.png
// module id = 747
// module chunks = 0